// Modules
import Lottie from 'react-lottie-player';
// Assets
import lottieJson from './VideoAnim.json';

export const VideoAnim = () => {
	return (
		<Lottie
			animationData={lottieJson}
			loop
			direction={1}
			play
			style={{ width: '200%', height: '100%' }}
			renderer='svg'
		/>
	);
};
